import React from "react";
import { Link } from "react-router-dom";
import { Layout } from "../../layouts/Layout";
import { INNER_ABOUT_IMG03, INNER_CHOOSE_IMG } from "../../lib/assets";
import "./AboutPage.css";

const values = [
  ["fas fa-user-shield", "Professional Integrity", "Honesty, independence and the highest professional standards in every engagement."],
  ["fas fa-users", "Client First Approach", "Solutions customised around each client’s structure, objectives and requirements."],
  ["fas fa-lock", "Confidentiality", "Sensitive business information handled with complete professional discretion."],
  ["fas fa-eye", "Transparency", "Clear communication, defined processes and transparent professional advice."],
  ["fas fa-award", "Professional Excellence", "Technical accuracy, attention to detail and consistent service quality."],
  ["fas fa-lightbulb", "Innovation", "Modern methods and practical ideas for evolving regulatory challenges."],
  ["fas fa-tasks", "Accountability", "Responsibility for commitments, deadlines and measurable outcomes."],
  ["fas fa-book-reader", "Continuous Learning", "Knowledge continuously upgraded with changing laws and regulations."],
  ["fas fa-balance-scale", "Ethical Governance", "Responsible, transparent and sustainable corporate governance practices."],
  ["fas fa-star", "Quality Commitment", "Disciplined review and quality assurance across every assignment."]
];

const reasons = [
  ["fas fa-user-check", "Client-Focused Solutions", "Customised solutions for each organisation’s unique regulatory challenges."],
  ["fas fa-briefcase", "Practical Business Advice", "Legally sound recommendations that remain commercially viable."],
  ["fas fa-clock", "Timely Compliance", "Proactive monitoring of statutory deadlines and regulatory obligations."],
  ["fas fa-user-tie", "Experienced Professionals", "Strong knowledge of corporate, commercial and regulatory laws."],
  ["fas fa-shield-alt", "Risk Mitigation", "Early identification of compliance gaps before they become liabilities."],
  ["fas fa-laptop-code", "Technology-Driven Practice", "Modern systems for faster execution, monitoring and accuracy."],
  ["fas fa-user-lock", "Complete Confidentiality", "The highest level of professional protection for client information."],
  ["fas fa-handshake", "Long-Term Association", "Strategic compliance partnerships rather than one-time service delivery."]
];

const quality = [
  "Accuracy", "Professional competence", "Timeliness", "Compliance excellence",
  "Continuous review", "Client satisfaction", "Ethical standards",
  "Regulatory precision", "Risk assessment", "Documentation excellence"
];

const mission = [
  "Deliver exceptional professional services",
  "Maintain absolute integrity and confidentiality",
  "Build long-term client relationships",
  "Promote ethical corporate governance",
  "Provide commercially practical legal solutions",
  "Continuously upgrade professional knowledge",
  "Create value beyond statutory compliance"
];

const AboutPage = () => (
  <Layout breadcrumb="About Us" title="About Us">
    <section className="ba-intro">
      <span className="ba-shape ba-shape-one" />
      <span className="ba-shape ba-shape-two" />
      <div className="container">
        <div className="row align-items-center g-5">
          <div className="col-lg-6">
            <div className="ba-image-wrap" data-aos="fade-right">
              <img src={INNER_ABOUT_IMG03} alt="BLAK & CO. professionals" />
              <div className="ba-image-overlay" />
              <div className="ba-float ba-float-one">
                <span><i className="fas fa-balance-scale" /></span>
                <div><strong>Corporate Governance</strong><small>Ethical and practical advisory</small></div>
              </div>
              <div className="ba-float ba-float-two">
                <span><i className="fas fa-shield-alt" /></span>
                <div><strong>Trusted Support</strong><small>Quality, confidentiality and timely execution</small></div>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="ba-copy" data-aos="fade-left">
              <span className="ba-tag">Excellence in Corporate Governance</span>
              <h2>Integrated corporate legal and secretarial solutions for modern businesses.</h2>
              <p className="ba-lead">M/s BLAK &amp; CO. is a professionally managed Company Secretaries Firm dedicated to providing integrated corporate legal and secretarial solutions across diverse industries.</p>
              <p>The Firm is founded on professional ethics, transparency, accountability and excellence. Our professionals possess extensive knowledge of corporate laws and regulatory frameworks.</p>
              <p>We work closely with clients to understand business objectives, identify regulatory challenges, mitigate legal risks and build governance mechanisms that strengthen long-term organisational performance.</p>
              <div className="ba-checks">
                {["Practical legal solutions","Timely regulatory execution","Complete confidentiality","Long-term advisory support"].map(x => <div key={x}><i className="fas fa-check" />{x}</div>)}
              </div>
              <div className="ba-actions">
                <Link to="/services" className="ba-btn">Explore Our Services <i className="fas fa-arrow-right" /></Link>
                <Link to="/contact-us" className="ba-contact"><span><i className="fas fa-phone-alt" /></span><div><small>Speak with our team</small><strong>Request Consultation</strong></div></Link>
              </div>
            </div>
          </div>
        </div>
        <div className="ba-stats" data-aos="fade-up">
          {[["360°","Corporate Advisory"],["100%","Professional Integrity"],["24/7","Compliance Monitoring"],["Long-Term","Client Relationships"]].map(([n,l]) => <div key={l}><strong>{n}</strong><span>{l}</span></div>)}
        </div>
      </div>
    </section>

    <section className="ba-beyond">
      <div className="container">
        <div className="row align-items-center g-5">
          <div className="col-lg-6">
            <div className="ba-beyond-copy" data-aos="fade-right">
              <span className="ba-tag ba-tag-light">Beyond Conventional Compliance</span>
              <h2>We simplify complex regulations into practical business solutions.</h2>
              <p>Professional advisory should reduce uncertainty, strengthen internal systems and support better management decisions.</p>
              {[
                ["fas fa-comments","Understand Your Business","We begin with your objectives, structure and regulatory responsibilities."],
                ["fas fa-search","Identify Risks Early","We assess compliance gaps before they become legal or operational liabilities."],
                ["fas fa-sitemap","Build Strong Governance","We create practical systems for accountability and sustainable performance."]
              ].map(([i,t,d]) => <article key={t}><span><i className={i} /></span><div><h3>{t}</h3><p>{d}</p></div></article>)}
            </div>
          </div>
          <div className="col-lg-6">
            <div className="ba-beyond-image" data-aos="fade-left">
              <img src={INNER_CHOOSE_IMG} alt="Corporate governance consultation" />
              <div className="ba-image-overlay" />
              <div className="ba-beyond-caption"><span><i className="fas fa-handshake" /></span><div><strong>Strategic Compliance Partner</strong><p>Support beyond statutory filing and documentation.</p></div></div>
            </div>
          </div>
        </div>
      </div>
    </section>




<section className="ba-purpose-redesign">
  <span className="ba-purpose-shape ba-purpose-shape-one"></span>
  <span className="ba-purpose-shape ba-purpose-shape-two"></span>

  <div className="container">
    <div className="ba-purpose-title" data-aos="fade-up">
      <span className="ba-tag">Our Purpose</span>

      <h2>
        A clear vision for trusted advisory and a mission built around
        business success.
      </h2>

      <p>
        Our vision defines where we aspire to go, while our mission guides
        how we create lasting value for every organisation we serve.
      </p>
    </div>

    <div className="ba-purpose-redesign-wrapper">
      <div className="ba-purpose-center-line"></div>

      <div className="row g-4 align-items-stretch">
        {/* Vision */}
        <div className="col-lg-6">
          <article
            className="ba-purpose-panel ba-vision-panel"
            data-aos="fade-right"
            data-aos-duration="900"
          >
            <div className="ba-purpose-panel-header">
              <div className="ba-purpose-panel-icon">
                <i className="fas fa-eye"></i>
              </div>

              <div className="ba-purpose-panel-label">
                <span>01</span>
                <small>Our Vision</small>
              </div>
            </div>

            <div className="ba-purpose-panel-content">
              <h3>
                To become one of India&apos;s most trusted and respected
                professional corporate advisory firms.
              </h3>

              <p>
                We aspire to deliver world-class company secretarial,
                governance, compliance and legal support while contributing
                towards transparent, ethical and sustainable corporate
                practices.
              </p>

              <div className="ba-purpose-pillar-list">
                <div className="ba-purpose-pillar">
                  <span>
                    <i className="fas fa-shield-alt"></i>
                  </span>

                  <div>
                    <h4>Trusted Advisory</h4>
                    <p>
                      Professional relationships built on integrity,
                      reliability and consistent execution.
                    </p>
                  </div>
                </div>

                <div className="ba-purpose-pillar">
                  <span>
                    <i className="fas fa-globe"></i>
                  </span>

                  <div>
                    <h4>World-Class Standards</h4>
                    <p>
                      Corporate advisory solutions aligned with evolving
                      business and regulatory expectations.
                    </p>
                  </div>
                </div>

                <div className="ba-purpose-pillar">
                  <span>
                    <i className="fas fa-leaf"></i>
                  </span>

                  <div>
                    <h4>Sustainable Governance</h4>
                    <p>
                      Promoting transparent, ethical and responsible
                      corporate practices.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <span className="ba-purpose-watermark">
              <i className="fas fa-eye"></i>
            </span>
          </article>
        </div>

        {/* Mission */}
        <div className="col-lg-6">
          <article
            className="ba-purpose-panel ba-mission-panel"
            data-aos="fade-left"
            data-aos-duration="900"
          >
            <div className="ba-purpose-panel-header">
              <div className="ba-purpose-panel-icon">
                <i className="fas fa-bullseye"></i>
              </div>

              <div className="ba-purpose-panel-label">
                <span>02</span>
                <small>Our Mission</small>
              </div>
            </div>

            <div className="ba-purpose-panel-content">
              <h3>
                To empower businesses through innovative, reliable and
                legally compliant solutions.
              </h3>

              <p>
                We enable organisations to focus on growth while maintaining
                the highest standards of corporate governance, regulatory
                compliance and professional accountability.
              </p>

              <div className="ba-mission-goals">
                {mission.map((item, index) => (
                  <div className="ba-mission-goal" key={item}>
                    <span className="ba-mission-goal-number">
                      {String(index + 1).padStart(2, "0")}
                    </span>

                    <span className="ba-mission-goal-check">
                      <i className="fas fa-check"></i>
                    </span>

                    <p>{item}</p>
                  </div>
                ))}
              </div>
            </div>

            <span className="ba-purpose-watermark">
              <i className="fas fa-bullseye"></i>
            </span>
          </article>
        </div>
      </div>
    </div>

    <div className="ba-purpose-bottom" data-aos="fade-up">
      <div className="ba-purpose-bottom-icon">
        <i className="fas fa-balance-scale"></i>
      </div>

      <div className="ba-purpose-bottom-content">
        <span>Our Professional Commitment</span>

        <h3>
          Creating value beyond statutory compliance.
        </h3>

        <p>
          We combine professional knowledge, practical business
          understanding and ethical conduct to support long-term corporate
          success.
        </p>
      </div>

      <Link to="/contact-us" className="ba-purpose-bottom-btn">
        Speak With Our Team
        <i className="fas fa-arrow-right"></i>
      </Link>
    </div>
  </div>
</section>

    <section className="ba-values">
      <div className="container">
        <div className="ba-heading" data-aos="fade-up">
          <span className="ba-tag">Our Values</span>
          <h2>Principles that guide our professional practice.</h2>
          <p>These values shape our decisions, relationships and commitment to quality.</p>
        </div>
        <div className="row g-4">
          {values.map(([icon,title,text],index) => (
            <div className="col-xl-4 col-md-6" key={title} data-aos="fade-up" data-aos-delay={(index%3)*80}>
              <article className="ba-card">
                <div className="ba-card-top"><span><i className={icon} /></span><strong>{String(index+1).padStart(2,"0")}</strong></div>
                <h3>{title}</h3><p>{text}</p><i className="ba-line" />
              </article>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="ba-why">
      <div className="container">
        <div className="row align-items-end g-4 ba-why-head">
          <div className="col-lg-7"><div className="ba-heading ba-heading-left"><span className="ba-tag">Why Choose Us</span><h2>Professional advice that protects your business and supports sustainable growth.</h2></div></div>
          <div className="col-lg-5"><p className="ba-side-copy">Choosing the right professional advisor is essential for effective compliance, responsible governance and long-term corporate success.</p></div>
        </div>
        <div className="row g-4">
          {reasons.map(([icon,title,text],index) => (
            <div className="col-xl-3 col-lg-4 col-md-6" key={title} data-aos="fade-up" data-aos-delay={(index%4)*70}>
              <article className="ba-card ba-why-card">
                <div className="ba-card-top"><span><i className={icon} /></span><strong>{String(index+1).padStart(2,"0")}</strong></div>
                <h3>{title}</h3><p>{text}</p><i className="ba-line" />
              </article>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="ba-quality">
      <div className="container">
        <div className="ba-quality-box">
          <div className="row align-items-center g-5">
            <div className="col-lg-5">
              <div data-aos="fade-right">
                <span className="ba-tag ba-tag-light">Our Quality Policy</span>
                <h2>Quality forms the foundation of every professional engagement.</h2>
                <p>Our quality assurance framework delivers legal accuracy, regulatory precision and professional reliability.</p>
                <div className="ba-quality-highlight"><span><i className="fas fa-check-double" /></span><div><strong>Multi-Level Review</strong><p>Every assignment undergoes multiple levels of professional review.</p></div></div>
              </div>
            </div>
            <div className="col-lg-7">
              <div className="ba-quality-grid">
                {quality.map((x,index) => <div key={x}><span>{String(index+1).padStart(2,"0")}</span><i className="fas fa-check" /><strong>{x}</strong></div>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="ba-cta-section">
      <div className="container">
        <div className="ba-cta" data-aos="zoom-in">
          <span className="ba-cta-icon"><i className="fas fa-handshake" /></span>
          <div><small>Trusted Corporate Compliance Partner</small><h2>Let us simplify your corporate compliance and governance requirements.</h2><p>Connect with our professionals for practical, reliable and business-focused support.</p></div>
          <aside><Link to="/contact-us">Request Consultation <i className="fas fa-arrow-right" /></Link><Link to="/services">Explore Services</Link></aside>
        </div>
      </div>
    </section>
  </Layout>
);

export default AboutPage;
